import { render, staticRenderFns } from "./AppointmentFilters.vue?vue&type=template&id=0b12a9a7&"
import script from "./AppointmentFilters.vue?vue&type=script&lang=js&"
export * from "./AppointmentFilters.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentFilters.vue?vue&type=style&index=0&id=0b12a9a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports